import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b3f887e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-fluid p-formgrid p-grid p-input-filled" }
const _hoisted_2 = { class: "p-field p-col-6" }
const _hoisted_3 = { for: "name" }
const _hoisted_4 = {
  key: 0,
  class: "p-error"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "p-error"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "p-field p-col-6" }
const _hoisted_9 = { for: "description" }
const _hoisted_10 = {
  key: 0,
  class: "p-error"
}
const _hoisted_11 = { class: "p-field p-col-6" }
const _hoisted_12 = { for: "dataType" }
const _hoisted_13 = {
  key: 0,
  class: "p-error"
}
const _hoisted_14 = { class: "p-field p-col-6" }
const _hoisted_15 = { for: "defaultValue" }
const _hoisted_16 = { class: "p-field p-col-6" }
const _hoisted_17 = { for: "locatorId" }
const _hoisted_18 = {
  key: 0,
  class: "p-field p-col-6"
}
const _hoisted_19 = { for: "subFieldName" }
const _hoisted_20 = { class: "p-dropdown-car-option" }
const _hoisted_21 = { class: "p-field p-col-6" }
const _hoisted_22 = { for: "fieldGroupId" }
const _hoisted_23 = { class: "p-field p-col-6" }
const _hoisted_24 = { for: "externalName" }
const _hoisted_25 = { class: "p-field p-col-3" }
const _hoisted_26 = { for: "mandatory" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = { class: "p-field p-col-3" }
const _hoisted_29 = { for: "readonly" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = { class: "p-field p-col-3" }
const _hoisted_32 = { for: "hidden" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = { class: "p-field p-col-3" }
const _hoisted_35 = { for: "forceValidation" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = { class: "p-field p-col-6" }
const _hoisted_38 = { for: "sameLineAsPreviousField" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = { class: "p-field p-col-3" }
const _hoisted_41 = { for: "trainable" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_43 = { class: "p-field p-col-3" }
const _hoisted_44 = { for: "useInReport" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_46 = { class: "p-field p-col-6" }
const _hoisted_47 = { for: "maxLength" }
const _hoisted_48 = { class: "p-field p-col-6" }
const _hoisted_49 = { for: "truncateType" }
const _hoisted_50 = { class: "p-mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_AmountSeparatorsForm = _resolveComponent("AmountSeparatorsForm")!
  const _component_DbLookupForm = _resolveComponent("DbLookupForm")!
  const _component_LookupFiltersView = _resolveComponent("LookupFiltersView")!
  const _component_TabView = _resolveComponent("TabView")!

  return (_openBlock(), _createBlock(_component_TabView, {
    onTabChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onTabChange($event.index)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_TabPanel, {
        header: _ctx.$t('Squeeze.DocumentClasses.FieldAttributes')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.Name')) + " *", 1),
              _createVNode(_component_InputText, {
                id: "name",
                modelValue: _ctx.v$.name.$model,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.name.$model) = $event)),
                modelModifiers: { trim: true },
                class: _normalizeClass({'p-invalid':_ctx.v$.name.$invalid && _ctx.showErrorMessage}),
                onChange: _ctx.onChangeInput,
                required: "true",
                autofocus: ""
              }, null, 8, ["modelValue", "class", "onChange"]),
              (_ctx.v$.name.required.$invalid && _ctx.showErrorMessage && !_ctx.v$.name.technicalValidation.$invalid)
                ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.DocumentClasses.Name')})), 1))
                : _createCommentVNode("", true),
              _hoisted_5,
              (_ctx.v$.name.technicalValidation.$invalid && _ctx.showErrorMessage)
                ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_ctx.$t('Forms.Val.OnlyAllowAlphaNumericUnderscore', { field: _ctx.$t('Squeeze.DocumentClasses.Name')})), 1))
                : (!!_ctx.value.id)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(_ctx.$t('Squeeze.Admin.WarnRename')), 1))
                  : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.Description')) + " *", 1),
              _createVNode(_component_InputText, {
                id: "description",
                modelValue: _ctx.v$.description.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.description.$model) = $event)),
                modelModifiers: { trim: true },
                class: _normalizeClass({'p-invalid':_ctx.v$.description.$invalid && _ctx.showErrorMessage}),
                onChange: _ctx.onChangeInput,
                required: "true"
              }, null, 8, ["modelValue", "class", "onChange"]),
              (_ctx.v$.description.$invalid && _ctx.showErrorMessage)
                ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.DocumentClasses.Description')})), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.DataType')) + " *", 1),
              _createVNode(_component_Dropdown, {
                id: "dataType",
                modelValue: _ctx.v$.dataType.$model,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.dataType.$model) = $event)),
                options: _ctx.dataTypes,
                optionValue: "id",
                optionLabel: "text",
                class: _normalizeClass({'p-invalid':_ctx.v$.dataType.$invalid && _ctx.showErrorMessage}),
                onChange: _ctx.onChangeDataType
              }, null, 8, ["modelValue", "options", "class", "onChange"]),
              ((!_ctx.v$.dataType.$model && _ctx.showErrorMessage))
                ? (_openBlock(), _createElementBlock("small", _hoisted_13, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.DocumentClasses.DataType')})), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.DefaultValue')), 1),
              _createVNode(_component_InputText, {
                id: "defaultValue",
                modelValue: _ctx.value.defaultValue,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.value.defaultValue) = $event)),
                modelModifiers: { trim: true },
                required: "true"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.Locator')), 1),
              _createVNode(_component_Dropdown, {
                id: "locatorId",
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onChangeLocator(_ctx.fieldEntry.locatorId))),
                modelValue: _ctx.value.locatorId,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.value.locatorId) = $event)),
                options: _ctx.locators,
                filter: true,
                autoFilterFocus: true,
                optionValue: "id",
                optionLabel: "description",
                showClear: true,
                editable: false,
                onShow: _ctx.showDropdownOverlay
              }, null, 8, ["modelValue", "options", "onShow"])
            ]),
            (!_ctx.tableField)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  (_ctx.subFields.length != 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.Subfield')), 1),
                        _createVNode(_component_Dropdown, {
                          id: "subFieldName",
                          modelValue: _ctx.value.subFieldName,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.value.subFieldName) = $event)),
                          options: _ctx.subFields,
                          filter: true,
                          autoFilterFocus: true,
                          optionValue: "subFieldName",
                          optionLabel: "name",
                          showClear: true,
                          editable: false,
                          onShow: _ctx.showDropdownOverlay
                        }, {
                          option: _withCtx((slotProps) => [
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("span", null, _toDisplayString(slotProps.option.name) + " (" + _toDisplayString(slotProps.option.subFieldName) + ")", 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "onShow"])
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.Group')), 1),
              _createVNode(_component_Dropdown, {
                id: "fieldGroupId",
                modelValue: _ctx.value.fieldGroupId,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.value.fieldGroupId) = $event)),
                options: _ctx.fieldGroups,
                optionValue: "id",
                optionLabel: "description"
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.ExternalName')), 1),
              _createVNode(_component_InputText, {
                id: "externalName",
                modelValue: _ctx.value.externalName,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.value.externalName) = $event)),
                modelModifiers: { trim: true },
                required: "true"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.Mandatory')), 1),
              _hoisted_27,
              _createVNode(_component_Checkbox, {
                id: "mandatory",
                modelValue: _ctx.value.mandatory,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.value.mandatory) = $event)),
                binary: true,
                onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onChangeCheckBox('mandatory')))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.ReadOnly')), 1),
              _hoisted_30,
              _createVNode(_component_Checkbox, {
                id: "readonly",
                modelValue: _ctx.value.readonly,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.value.readonly) = $event)),
                binary: true,
                onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onChangeCheckBox('readonly')))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.Hidden')), 1),
              _hoisted_33,
              _createVNode(_component_Checkbox, {
                id: "hidden",
                modelValue: _ctx.value.hidden,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.value.hidden) = $event)),
                binary: true,
                onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onChangeCheckBox('hidden')))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.ForceValidation')), 1),
              _hoisted_36,
              _createVNode(_component_Checkbox, {
                id: "forceValidation",
                modelValue: _ctx.value.forceValidation,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.value.forceValidation) = $event)),
                binary: true,
                onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onChangeCheckBox('forceValidation')))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.ShowFieldNextToPreviousField')), 1),
              _hoisted_39,
              _createVNode(_component_Checkbox, {
                id: "sameLineAsPreviousField",
                modelValue: _ctx.value.sameLineAsPreviousField,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.value.sameLineAsPreviousField) = $event)),
                binary: true,
                class: "checkbox-previous-field"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.Trainable')), 1),
              _hoisted_42,
              _createVNode(_component_Checkbox, {
                id: "trainable",
                modelValue: _ctx.value.trainable,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.value.trainable) = $event)),
                binary: true,
                onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onChangeCheckBox('trainable'))),
                class: "checkbox-previous-field",
                disabled: _ctx.value.name === 'Creditor'
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.UseInReport')), 1),
              _hoisted_45,
              _createVNode(_component_Checkbox, {
                id: "useInReport",
                modelValue: _ctx.value.useInReport,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.value.useInReport) = $event)),
                binary: true,
                onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onChangeCheckBox('useInReport'))),
                class: "checkbox-previous-field"
              }, null, 8, ["modelValue"])
            ]),
            (_ctx.value.dataType === 'Text')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.FieldLength')), 1),
                    _createVNode(_component_InputNumber, {
                      id: "maxLength",
                      modelValue: _ctx.value.maxLength,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.value.maxLength) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.CutContent')), 1),
                    _createVNode(_component_Dropdown, {
                      id: "truncateType",
                      modelValue: _ctx.value.truncateType,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.value.truncateType) = $event)),
                      options: _ctx.truncateTypes,
                      optionValue: "id",
                      optionLabel: "text",
                      onShow: _ctx.showDropdownOverlay,
                      disabled: _ctx.value.maxLength < 1
                    }, null, 8, ["modelValue", "options", "onShow", "disabled"])
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["header"]),
      (_ctx.store.state.featureSet.configurableFieldAmountFormatting)
        ? (_openBlock(), _createBlock(_component_TabPanel, {
            key: 0,
            disabled: !_ctx.value.dataType || _ctx.value.dataType !== 'Amount',
            header: _ctx.$t('Squeeze.General.Presentation')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AmountSeparatorsForm, {
                amountSeparatorData: {thousandSeparator: _ctx.value.thousandSeparator, decimalSeparator: _ctx.value.decimalSeparator, decimalPlaces: _ctx.value.decimalPlaces},
                onUpdate: _ctx.onChangeAmountSeparators
              }, null, 8, ["amountSeparatorData", "onUpdate"])
            ]),
            _: 1
          }, 8, ["disabled", "header"]))
        : _createCommentVNode("", true),
      _createVNode(_component_TabPanel, {
        disabled: !_ctx.value.dataType || _ctx.value.dataType !== 'Text',
        header: _ctx.$t('Squeeze.DocumentClasses.DbLookup')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DbLookupForm, {
            dbLookUpEntry: _ctx.value.lookup,
            showErrorMessage: _ctx.showErrorMessage,
            onUpdate: _ctx.onUpdateFieldLookup
          }, null, 8, ["dbLookUpEntry", "showErrorMessage", "onUpdate"]),
          (_ctx.value.id && _ctx.value.lookup.active)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.FieldFilterInfo')), 1),
                _createVNode(_component_LookupFiltersView, {
                  "document-class-id": _ctx.fieldEntry.documentClassId,
                  "field-id": _ctx.fieldEntry.id,
                  "table-id": _ctx.fieldEntry.lookup.tableId
                }, null, 8, ["document-class-id", "field-id", "table-id"])
              ], 64))
            : (_ctx.value.lookup.active)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.DocumentClasses.PleaseSaveFieldFirst')), 1)
                ], 64))
              : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["disabled", "header"])
    ]),
    _: 1
  }))
}